/*
 * Public API Surface of ngx-bootstrap-slider
 */

export * from './lib/ngx-bootstrap-slider.service';
export * from './lib/ngx-bootstrap-slider.component';
export * from './lib/ngx-bootstrap-slider.module';
export * from './lib/slider/slider.component';